/*
 * @Author: 陈朝晖
 * @Date: 2022-04-12 10:08:21
 * @LastEditTime: 2024-02-04 16:05:22
 * @Description:
 */

Object.freeze(window.dazeRunningConfing);

import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";

import "./plugins/element.js";
import ajax from "./plugins/ajax.js";
Vue.prototype.$ajax = ajax;
import "./plugins/directive.js";
import utils from "./assets/utils.js";
Vue.prototype.$utils = utils;
import filters from "./filters/filter";

import plugins from "@packages/exports/plugins";
import install from "@packages/install.js";
install();
// import "daze-components-demo/lib/daze-components-demo.css";

const {
  filters: npmFilters,
  directives: { onlyNum, dialogDrag },
  prototypes: { bus },
} = plugins;

Vue.use(npmFilters);
Vue.use(onlyNum);
Vue.use(dialogDrag);
Vue.use(bus);

Vue.use(filters);

// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://2e13d2c3d22749f998048a08415b1fff@js.hhczy.com/4",
//   release: process.env.NODE_ENV === "development" ? "1.1.0-dev" : "1.1.0-prod",

//   integrations: [
//     new VueIntegration({
//       Vue,
//       tracing: true,
//     }),
//     new Integrations.BrowserTracing(),
//   ],
//   tracesSampleRate: 1,
// });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
